import { httpService } from "./http.service";

const BASE_URL = "superAdmin";

export const superAdminService = {
  getStats,
  getCompanysStats,
  createSuper,
  getListAdmins,
  validate,
  remove,
  toggleSuperAdminStatus,
  updateSuperAdmin,
  createGlobalNotice,
  deleteNotice,
  editNotice,
  getListNotices,
  createPlan,
  editPlan,
  deletePlan,
  scheduleRemoval,
  testEmailSend
}

function getAuthHeader(token) {
  return {
    headers: { Authorization: `Bearer ${token}` }
  };
}

async function getStats(token) {
  const data = await httpService.get(`${BASE_URL}/stats`, getAuthHeader(token));
  return data;
}

async function getCompanysStats(token) {
  const data = await httpService.get(`${BASE_URL}/companys-stats`, getAuthHeader(token));
  return data;
}

async function createSuper(payload, token) {
  const data = await httpService.post(`${BASE_URL}/create`, payload, getAuthHeader(token));
  return data;
}

async function getListAdmins(token) {
  const data = await httpService.get(`${BASE_URL}/`, getAuthHeader(token));
  return data;
}

async function validate(email, token) {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`
    },
    params: {
      email
    }
  };
  const data = await httpService.get(`${BASE_URL}/validate`, config);
  return data;
}

async function remove(id, token) {
  const data = await httpService.delete(`${BASE_URL}/delete`, {
    headers: {
      Authorization: `Bearer ${token}`
    },
    params: {
      id
    }
  });
  return data;
}

export async function toggleSuperAdminStatus(id, token) {
  const res = await httpService.patch(`${BASE_URL}/toggle-status/${id}`, getAuthHeader(token));
  return res.data;
}

export async function updateSuperAdmin(data, token) {
  const response = await httpService.patch(`${BASE_URL}/update-superAdmin`, data, getAuthHeader(token));
  return response;
}

export async function createGlobalNotice(notice, token) {
  const response = await httpService.post(`${BASE_URL}/createNotices`, notice, getAuthHeader(token));
  return response;
};


export async function deleteNotice(id, token) {
  const response = await httpService.delete(`${BASE_URL}/deleteNotice/${id}`, getAuthHeader(token));
  return response;
};

export async function editNotice(id, updatedData, token) {
  const response = await httpService.put(`${BASE_URL}/notices/${id}`, updatedData, getAuthHeader(token));
  return response;
};

export async function getListNotices(token) {
  const response = await httpService.get(`${BASE_URL}/notices`, getAuthHeader(token));
  return response;
};

async function createPlan(payload, token) {
  const data = await httpService.post(`${BASE_URL}/plans`, payload, getAuthHeader(token));
  return data;
}

async function editPlan(payload, token) {
  const data = await httpService.put(`${BASE_URL}/editPlan/${payload?._id}`, payload, getAuthHeader(token));
  return data;
}

async function deletePlan(planId, token) {
  const data = await httpService.post(`${BASE_URL}/deletePlan/${planId}`, getAuthHeader(token));
  return data;
}

async function scheduleRemoval(planId, token) {
  const data = await httpService.post(`${BASE_URL}/SchedulePlanRemoval/${planId}`, getAuthHeader(token));
  return data;
}

async function testEmailSend(token, params) {
  const data = await httpService.post(`${BASE_URL}/testEmailSend`, params, getAuthHeader(token));
  return data;
}
